// services/firestoreBatch.js
//
// Batch-fetch docs of one collection by id with chunked
// `where(documentId(), "in", chunk)` queries (FIRESTORE_IN_LIMIT per query, in
// parallel) instead of one getDoc per row. Returns Map<docId, data>; a missing
// doc is absent from the map. A failed chunk is skipped (treated as not found)
// unless `strict`, which rethrows so the caller can keep its last good data.
import { collection, documentId, getDocs, query, where } from "firebase/firestore";
import { db } from "../config/firebase";
import { chunk, FIRESTORE_IN_LIMIT } from "../utils/arrays";

export async function fetchDocsByIds(collectionName, ids, { strict = false } = {}) {
  const uniqueIds = [...new Set(ids || [])].filter(Boolean);
  const result = new Map();
  const snapshots = await Promise.all(
    chunk(uniqueIds, FIRESTORE_IN_LIMIT).map((idsChunk) =>
      getDocs(query(collection(db, collectionName), where(documentId(), "in", idsChunk))).catch(
        (error) => {
          if (strict) throw error;
          return null;
        }
      )
    )
  );
  for (const snapshot of snapshots) {
    if (!snapshot) continue;
    for (const docSnap of snapshot.docs) result.set(docSnap.id, docSnap.data());
  }
  return result;
}
